<template>
  <div class="container-box" v-loading="oLoading.pageLoading">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">{{ pageTitle }}</template>
        <div class="splitline"></div>
      </QS-h3-title>
      <div class="content-box">
        <div class="content-box__title">
          <div class="icon"></div>
          <span>基础信息</span>
        </div>
        <div class="content-box__content">
          <div class="content-item basic-info">
            <p class="title">方案信息</p>
            <el-form ref="formRef" :rules="baseRules" :model="baseDefaultValue">
              <column-box :column="2">
                <template v-if="mode === MODE_TYPE.EDIT">
                  <el-form-item label="方案ID" prop="id">
                    <span>{{ baseDefaultValue.id }}</span>
                  </el-form-item>
                  <el-form-item label="创建时间" prop="gmtCreate">
                    <span>{{ baseDefaultValue.gmtCreate }}</span>
                  </el-form-item>
                </template>
                <el-form-item label="名称" prop="name">
                  <el-input v-model="baseDefaultValue.name" clearable placeholder="不对外展示，最多50字" maxlength="50" />
                </el-form-item>
                <CarBrandSeriesModel
                  v-model="baseDefaultValue.brandSeriesModel"
                  :brandSeriesModelName="baseDefaultValue.brandSeriesModelName"
                  :showModel="true"
                  :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
                  :disabled="isOnline"></CarBrandSeriesModel>
                <el-form-item label="城市" prop="cityCodes">
                  <ExpandableText
                    v-if="isOnline"
                    :content="baseDefaultValue.cityNames.join('、')"
                    :max-lines="3"
                  />
                  <QS-select
                    v-else
                    v-model="baseDefaultValue.cityCodes"
                    clearable
                    filterable
                    multiple
                    collapse-tags
                    placeholder="请选择城市"
                    :disabled="cityDisabled"
                    :option-data="allCities"
                    :option-config="{
                      labelKey: 'city',
                      valueKey: 'adcode'
                    }"
                    popper-class="plan-city-popper"
                  >
                  </QS-select>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
          <div class="content-item">
            <p class="title">租赁规则</p>
            <!-- 确认租赁信息 -->
            <personSchemeRentInfo
              ref="schemeRentInfo"
              :defaultRentInfo="leaseInfoParams"
              :tableData="defaultTable"
              @updateInfo="updateRentDateInfo"
              @formChange="formChange"
              :disabled="isOnline"
            />
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="content-box__title">
          <div class="icon"></div>
          <span>履约条款</span>
        </div>
        <div class="content-box__content">
          <!-- 租赁合同模板弹窗-->
          <ChooseContractTemplate
            ref="chooseContractTemplateRef"
            :defaultValue="defaultTemplateValue"
            source="leaseScheme"
            @saveSuccess="setTemplateIdAndAIResultInfo" />

          <!-- 司机合作模式组件 -->
          <DriverCooperationRules
            ref="driverCooperRef"
            :rentDateInfo="rentDateInfo"
            :payPlanFee="leaseInfoParams.payPlanFee"
            :sceneType="'leasePlan'"
            v-if="rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
            @autoAnchor="autoAnchor"
          />

          <!-- 租赁支付计划表格 -->
          <div v-else-if="showRentPlan" class="content-item">
            <p class="title">租赁账单</p>
            <RentPlanConfig
              ref="RentPlanConfig"
              :defaultTableData="feeTableData"
              :rentDateInfo="rentDateInfo"
              :specialType="1"
              :scene="SCENE_TYPE.LEASE_PLAN"
              :configDisabled="false"
              @autoAnchor="autoAnchor"
            />
          </div>

          <!-- 履约条款组件 -->
          <LeaseRules
            v-if="baseDefaultValue.templateId"
            :rentDataInfo="rentDateInfo"
            ref="leaseRulesRef"
            :loading="leaseRulesLoading"
          />

        </div>
      </div>
      <!-- 操作 -->
      <template slot="bottomAction">
        <el-button @click="goPageBacks" size="mini">取消</el-button>
        <el-button
          :loading="oLoading.submit"
          type="primary"
          size="mini"
          @click="submitHandle"
          >提交</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
// api
import { createPersonalPlan, editPersonalPlan } from '@/api/domain/purchase.js'
import { getAiAnalysisResult } from '@/api/domain/organize.js'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict.js'
// 组件
import ChooseContractTemplate from '@/components/ChooseContractTemplate'
import LeaseRules from './LeaseRules'
import DriverCooperationRules from '@/components/DriverCooperationRules'
import ExpandableText from '@/components/ExpandableText/index.vue'
import personSchemeRentInfo from '@/components/rentCalculateConfig/personSchemeRentInfo.vue'
import RentPlanConfig from '@/components/RentPlanConfig/index.vue'

// vuex
import { mapGetters } from 'vuex'

import { SCENE_TYPE } from '@/components/RentPlanConfig/config'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'
import WindowCommunication from '@/utils/windowCommunication'
import { omit } from 'lodash'
import { MODE_TYPE, MODE_TYPE_TEXT } from '../const.js'
import addMixin from '../mixin/indexNew.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'AddPersonEditNew',
  mixins: [addMixin],
  components: {
    personSchemeRentInfo,
    RentPlanConfig,
    DriverCooperationRules,
    ChooseContractTemplate,
    ExpandableText,
    LeaseRules,
  },
  props: {
    // 编辑模式
    mode: {
      type: String,
      default: MODE_TYPE.ADD,
    },
  },
  data() {
    return {
      leaseInfoParams: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: '', // 赠送天数
        preFreeRentDays: '', // 前置免租天数
        rentPeriodType: '', // 租赁周期单位
        payMode: '', // 收款方式
      },
      rentDateInfo: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: '', // 赠送天数
        preFreeRentDays: '', // 前置免租天数
        rentPeriodType: '', // 租赁周期单位
        payMode: '',
      },
      oLoading: {
        pageLoading: true,
      },
      leaseRulesLoading: false,
      pageTitle: `${MODE_TYPE_TEXT[this.mode]}个人租赁方案`,
      baseDefaultValue: {
        id: '',
        templateId: '',
        cityCodes: [],
        brandId: '',
        seriesId: '',
        modelId: '',
        state: '',
        cityNames: [],
        brandSeriesModel: {},
        brandSeriesModelName: {},
        gmtCreate: '',
        name: '',
      },
      defaultTable: [],
      feeTableData: [],
      id: '',
      SCENE_TYPE, // 场景类型
      MODE_TYPE, // 模式类型
      CATEGORY_CODE_MAP,
      defaultTemplateValue: {
        id: '', // 模板id
        name: '', // 模板名称
      },
      CAR_MODEL_FILTER_SCENE,
    }
  },
  computed: {
    ...mapGetters(['allCities']),
    cityDisabled() {
      return !!this.$route.query?.scene
    },
    isOnline() {
      return this.baseDefaultValue.state === 1 && this.mode === MODE_TYPE.EDIT
    },
    showRentPlan() {
      return this.rentDateInfo.rentCategory && this.baseDefaultValue.templateId
    },
  },
  created() {
    this.id = this.$route.query.id || ''
    if (this.allCities.length === 0) {
      this.$store.dispatch('getCityListFn')
    }
    if (this.$route.query?.scene) {
      this.baseDefaultValue.modelId = this.$route.query?.modelId ? Number(this.$route.query?.modelId) : ''
      this.baseDefaultValue.cityCodes = this.$route.query?.cityCode
        ? [this.$route.query?.cityCode]
        : []
      // 从商品管理新增租赁方案进来的时候会携带品牌车系车型信息，需要赋值
      this.baseDefaultValue.brandId = this.$route.query?.brandId ? Number(this.$route.query?.brandId) : ''
      this.baseDefaultValue.seriesId = this.$route.query?.seriesId ? Number(this.$route.query?.seriesId) : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
    }
  },
  watch: {
    'baseDefaultValue.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.baseDefaultValue.brandId = brandId
        this.baseDefaultValue.seriesId = seriesId
        this.baseDefaultValue.modelId = modelId
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate('brandId')
          this.$refs.formRef.clearValidate('modelId')
        })
      },
      deep: true,
    },
    'baseDefaultValue.templateId': {
      async handler(val) {
        if (val) {
          try {
            this.leaseRulesLoading = true
            const { code, data } = await getAiAnalysisResult({ id: val })
            if (code === 1) {
              this.$refs.leaseRulesRef.setFormData({
                rentCarRuleTip: data.rentCarRuleTip,
                returnCarRuleTip: data.returnCarRuleTip,
                rentCarRule: data.rentCarRule,
                returnCarRule: data.returnCarRule,
              })
            }
          } finally {
            this.leaseRulesLoading = false
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = {
        ...val,
      }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.schemeRentInfo.autoAnchorPoint(toastFlag)
    },
    // 设置值
    // eslint-disable-next-line vue/no-unused-properties
    async setData(data) {
      // 维保方案回显
      this.baseDefaultValue.id = this.id
      this.baseDefaultValue.gmtCreate = data.gmtCreate
      this.baseDefaultValue.name = data.name
      // 设置 modelId-车型
      this.baseDefaultValue.brandId = !this.validateIsEmptyValue(data.brandId)
        ? Number(data.brandId)
        : ''
      this.baseDefaultValue.seriesId = !this.validateIsEmptyValue(data.seriesId)
        ? Number(data.seriesId)
        : ''
      this.baseDefaultValue.modelId = !this.validateIsEmptyValue(data.modelId)
        ? Number(data.modelId)
        : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
      this.baseDefaultValue.brandSeriesModelName = {
        brandName: data.brandName,
        seriesName: data.seriesName,
        modelName: data.modelName,
      }
      // 合同模版id不为空且是启用状态才赋值
      this.baseDefaultValue.templateId =
        !this.validateIsEmptyValue(data.templateId) &&
        data.templateState === TEMPLATE_STATE_MAP.QI_YONG
          ? Number(data.templateId)
          : ''
      this.baseDefaultValue.cityCodes = data.cityCodes
      this.baseDefaultValue.cityNames = data.cityNames
      this.baseDefaultValue.state = data.state
      // 配置信息
      this.leaseInfoParams.rentCategory = data.rentCategory
      this.leaseInfoParams.rentPeriod = !this.validateIsEmptyValue(
        data.rentPeriod,
      )
        ? String(data.rentPeriod)
        : ''
      this.leaseInfoParams.presentDays = data.presentDays
        ? String(data.presentDays)
        : ''
      this.leaseInfoParams.preFreeRentDays = data.preFreeRentDays
        ? String(data.preFreeRentDays)
        : ''
      this.leaseInfoParams.rentPeriodType = data.rentPeriodType
      this.leaseInfoParams.payPlanFee = data.payPlanFee
      this.leaseInfoParams.payMode = data.payMode
      this.rentDateInfo = {
        ...this.leaseInfoParams,
      }
      this.defaultTable = data.orderPlanFeeList
      // 设置模板信息
      this.defaultTemplateValue.id = data.templateId
      this.defaultTemplateValue.name = data.templateName

      // 设置履约条款信息
      this.$nextTick(() => {
        if (this.$refs.leaseRulesRef) {
          this.$refs.leaseRulesRef.setFormData(data.performanceTerms)
        }
      })
    },
    // 提交事件
    submitHandle() {
      // 处理方案基本信息
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请先将【方案基本信息】的必填字段填写完整')
          this.$refs?.formRef?.$el?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          })
          return
        }

        // 处理租赁基本信息
        const rentInfoData = this.$refs.schemeRentInfo.getFormData() // 确认租赁信息
        if (!rentInfoData) return // 表单未通过校验

        let payPlanFee = null
        let tableData = null

        if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          // 获取司机合作模式表单
          payPlanFee = await this.$refs.driverCooperRef.getFormData()

          if (!payPlanFee) {
            this.$message.error('请填写司机规则带有红色 * 的内容')
            return
          }
        } else {
          if (!this.$refs.RentPlanConfig) {
            this.$message.error('请选择合同模板')
            return
          }
          // 处理table
          tableData = this.$refs.RentPlanConfig.getFormData() // table
          if (!tableData) return // table未通过校验
        }

        const baseInfoData = { ...this.baseDefaultValue }
        const templateIdValid = await this.$refs.chooseContractTemplateRef.validateForm()
        if (!templateIdValid) {
          this.$message.error('请选择合同模板')
          return
        }

        // 获取履约条款数据
        const leaseRuleData = await this.$refs.leaseRulesRef.validateForm()

        if (!leaseRuleData) {
          return
        }

        // 如果没有值，search-box获取值默认会把这个字段名不返回，所以这时候把字段动态加上
        const fieldList = ['explanation', 'introduction']
        for (const field of fieldList) {
          if (!baseInfoData[field]) {
            baseInfoData[field] = ''
          }
        }
        this.postParams = {
          orderType: 1, // 客户类型 1个人
          ...baseInfoData,
          ...rentInfoData,
          rentFeeList: tableData,
          payPlanFee,
          state: 10, // 默认上架
          rentCarRule: leaseRuleData?.rentCarRule,
          returnCarRule: leaseRuleData?.returnCarRule,
        }

        if (this.mode === MODE_TYPE.EDIT && this.id) {
          this.editLeasingSchemeConfigFun()
        } else {
          this.addPersonPlanSchemeFn()
        }
      })
    },
    // 新增个人租赁方案
    async addPersonPlanSchemeFn() {
      const addPostParams = { ...this.postParams }
      if (!addPostParams.presentDays) {
        addPostParams.presentDays = 0
      }
      if (!addPostParams.preFreeRentDays) {
        addPostParams.preFreeRentDays = 0
      }
      // 集团侧 & 从新增产品跳转过来带的 goUpState 参数的，添加 state ，可使得方案直接上架，保证从此页面再跳转回新增商品的时候，在选择租赁方案的时候可以选择上
      if (this.$route.query.goUpState) {
        addPostParams.state = 10
      }
      delete addPostParams.brandSeriesModel
      this.oLoading.submit = true
      const res = await createPersonalPlan(omit(addPostParams, 'id')).finally(
        () => {
          this.oLoading.submit = false
        },
      )
      if (res.code === 1) {
        this.$message.success('添加成功')
        // 添加成功后，记录下添加成功的标识，用于在添加成功后，刷新列表，并选中刚添加的方案
        if (this.$route.query.scene) {
          const communication = new WindowCommunication('lease_scheme_added')
          communication.send(true)
          // 关闭window
          window.close()
          return
        }
        this.goPageBacks(true)
      }
    },
    // 编辑租赁方案
    async editLeasingSchemeConfigFun() {
      this.oLoading.submit = true
      const params = {
        ...this.postParams,
        id: this.id,
      }
      if (!this.postParams.maintenancePlanId) {
        params.maintenancePlanId = 0
      }
      delete params.brandSeriesModel
      const res = await editPersonalPlan(params).finally(() => {
        this.oLoading.submit = false
      })
      if (res.code === 1) {
        this.$message.success('修改成功')
        if (this.$route.query.scene) {
          const communication = new WindowCommunication('lease_scheme_added')
          communication.send({
            type: 'lease_scheme_edit',
            data: this.id,
          })
          // 关闭window
          window.close()
          return
        }
        this.goPageBacks(true)
      }
    },
    formChange() {
      // 司机合作模式切换预计租赁日期清空司机结算
      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.$refs.driverCooperRef.clearFormData()
      }
    },
    setTemplateIdAndAIResultInfo(info) {
      this.baseDefaultValue.templateId = info.templateId
    },
  },
}
</script>
<style lang="scss" scoped>
.qs-scrollerBox {
  margin-right: 0;
}
::v-deep .bottom-action-inner {
  bottom: 12px;
}
::v-deep .qs-h4-no-border {
  padding-bottom: 0;
}
.content-box {
  &__title {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #1D2129;
    display: flex;
    align-items: center;
    background: #F7F9FD;
    height: 38px;
    .icon {
      width: 4px;
      height: 16px;
      background: #2A6BFF;
      margin-right: 8px;
    }
  }
  &__content {
    width: 720px;
    margin: 0 auto;
  }
}
.content-item {
  .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: #1D2129;
    margin-bottom: 11px;
  }
}
.basic-info {
  ::v-deep .el-column-box {
    gap: 0 24px;
  }
  ::v-deep .el-form-item {
    display: flex;
    flex-direction: column;
    width: 348px !important;
  }
  ::v-deep .el-form-item__label {
    justify-content: flex-start;
  }
  ::v-deep .el-cascader {
    width: 100%;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  ::v-deep .column-box {
    gap: 0 24px;
  }
}

</style>
<style lang="scss">
.plan-city-popper {
  .el-select-dropdown__wrap {
    width: 100% !important;
  }
}
</style>
